import { type Trigger, TriggerType } from '@keyvue/one-api-client';

// eslint-disable-next-line import/prefer-default-export
export function getMergeTagsForTrigger(trigger: Trigger) {
    switch (trigger.type.value) {
        case TriggerType.REALWORKS_AGENDA.value: return getMergeTagsForAgendaTrigger();
        case TriggerType.REALWORKS_TAAK.value: return getMergeTagsForTaakTrigger();
        case TriggerType.REALWORKS_RELATIE.value: return getMergeTagsForRelatieTrigger();
        case TriggerType.REALWORKS_KENMERK.value: return getMergeTagsForKenmerkTrigger();
        case TriggerType.REALWORKS_BIRTHDAY.value: return getMergeTagsForBirthdayTrigger();
        default: return [];
    }
}

function getMergeTagsForAgendaTrigger() {
    return [
        ...getContactMergeTags(),
        ...getTeamMergeTags(),
        ...getMedewerkerMergeTags(
            'Medewerker met wie de afspraak is',
            'realworksAgenda.medewerker',
        ),
        {
            name: 'Type afspraak',
            value: '{{ realworksAgenda.agendatype|default }}',
        },
        {
            name: 'Locatie van de afspraak',
            value: '{{ realworksAgenda.locatie|default }}',
        },
        {
            name: 'Datum van de afspraak (kort)',
            value: '{{ realworksAgenda.begintijd|default|format_date("short") }}',
        },
        {
            name: 'Datum van de afspraak (lang)',
            value: '{{ realworksAgenda.begintijd|default|format_date("long") }}',
        },
        {
            name: 'Tijd van de afspraak',
            value: '{{ realworksAgenda.begintijd|default|format_time("short") }}',
        },
        {
            name: 'Dag van de afspraak (bijv. maandag)',
            value: '{{ realworksAgenda.begintijd|default|format_date(pattern="cccc") }}',
        },
        ...getWonenObjectMergeTags(
            'Woning',
            'realworksAgenda.wonenObject',
        ),
    ];
}

function getMergeTagsForTaakTrigger() {
    return [
        ...getContactMergeTags(),
        ...getTeamMergeTags(),
        ...getMedewerkerMergeTags(
            'Medewerker voor wie de taak is',
            'realworksTaak.medewerker',
        ),
        {
            name: 'Type taak',
            value: '{{ realworksTaak.type|default }}',
        },
        {
            name: 'Datum gereed van de taak (kort)',
            value: '{{ realworksTaak.datumGereed|default|format_date("short") }}',
        },
        {
            name: 'Datum gereed van de taak (lang)',
            value: '{{ realworksTaak.datumGereed|default|format_date("long") }}',
        },
        {
            name: 'Tijd gereed van de taak',
            value: '{{ realworksTaak.datumGereed|default|format_time("short") }}',
        },
        {
            name: 'Dag gereed van de taak (bijv. maandag)',
            value: '{{ realworksTaak.datumGereed|default|format_date(pattern="cccc") }}',
        },
        ...getWonenObjectMergeTags(
            'Woning',
            'realworksTaak.wonenObject',
        ),
    ];
}

function getMergeTagsForRelatieTrigger() {
    return [
        ...getContactMergeTags(),
        ...getTeamMergeTags(),
        ...getMedewerkerMergeTags(
            'Accountmanager van de relatie',
            'realworksRelatie.accountmanager',
        ),
    ];
}

function getMergeTagsForKenmerkTrigger() {
    return [
        ...getContactMergeTags(),
        ...getTeamMergeTags(),
        ...getMedewerkerMergeTags(
            'Accountmanager van de relatie',
            'realworksRelatie.accountmanager',
        ),
    ];
}

function getMergeTagsForBirthdayTrigger() {
    return [
        ...getContactMergeTags(),
        {
            name: 'Contact: geboortedatum (kort)',
            value: '{{ contact.birthDate|default|format_date("short") }}',
        },
        {
            name: 'Contact: geboortedatum (lang)',
            value: '{{ contact.birthDate|default|format_date("lang") }}',
        },
        {
            name: 'Contact: leeftijd op verjaardag',
            value: '{{ contact.ageOnBirthDay|default }}',
        },
        ...getTeamMergeTags(),
        ...getMedewerkerMergeTags(
            'Accountmanager van de relatie',
            'realworksRelatie.accountmanager',
        ),
    ];
}

function getContactMergeTags() {
    return [
        {
            name: 'Contact: aanhef',
            value: '{{ contact.longSalutation|default }}',
        },
        {
            name: 'Contact: aanhef (kort)',
            value: '{{ contact.shortSalutation|default }}',
        },
        {
            name: 'Contact: voornaam',
            value: '{{ contact.name.firstName|default }}',
        },
        {
            name: 'Contact: achternaam (inclusief tussenvoegsel)',
            value: '{{ contact.name.fullLastName|default }}',
        },
        {
            name: 'Contact: adres',
            value: '{{ contact.address.fullStreet|default }}',
        },
        {
            name: 'Contact: adres (incl. postcode en woonplaats)',
            value: '{{ contact.address.fullAddress|default }}',
        },
        {
            name: 'Contact: straatnaam',
            value: '{{ contact.address.street|default }}',
        },
        {
            name: 'Contact: huisnummer (incl. toevoeging)',
            value: '{{ contact.address.fullNumber|default }}',
        },
        {
            name: 'Contact: postcode',
            value: '{{ contact.address.postalCode|default }}',
        },
        {
            name: 'Contact: woonplaats',
            value: '{{ contact.address.city|default }}',
        },
        {
            name: 'Contact: e-mailadres',
            value: '{{ contact.email|default }}',
        },
        {
            name: 'Contact: telefoonnummer',
            value: '{{ contact.phoneNumber|default }}',
        },
        {
            name: 'Contact: mobielnummer',
            value: '{{ contact.mobilePhoneNumber|default }}',
        },
    ];
}

function getTeamMergeTags() {
    return [
        {
            name: 'Vestiging: naam',
            value: '{{ team.displayName|default(team.name|default) }}',
        },
        {
            name: 'Vestiging: adres',
            value: '{{ team.address.fullStreet|default }}',
        },
        {
            name: 'Vestiging: adres (incl. postcode en woonplaats)',
            value: '{{ team.address.fullAddress|default }}',
        },
        {
            name: 'Vestiging: straatnaam',
            value: '{{ team.address.street|default }}',
        },
        {
            name: 'Vestiging: huisnummer',
            value: '{{ team.address.fullNumber|default }}',
        },
        {
            name: 'Vestiging: postcode',
            value: '{{ team.address.postalCode|default }}',
        },
        {
            name: 'Vestiging: woonplaats',
            value: '{{ team.address.city|default }}',
        },
        {
            name: 'Vestiging: telefoonnummer',
            value: '{{ team.phoneNumber|default }}',
        },
        {
            name: 'Vestiging: website',
            value: '{{ team.website|default }}',
        },
        {
            name: 'Vestiging: e-mailadres',
            value: '{{ team.email|default }}',
        },
        {
            name: 'Vestiging: Facebook URL',
            value: '{{ team.facebookUrl|default }}',
        },
        {
            name: 'Vestiging: Instagram URL',
            value: '{{ team.instagramUrl|default }}',
        },
        {
            name: 'Vestiging: LinkedIn URL',
            value: '{{ team.linkedinUrl|default }}',
        },
        {
            name: 'Vestiging: YouTube URL',
            value: '{{ team.youtubeUrl|default }}',
        },
        {
            name: 'Vestiging: X URL',
            value: '{{ team.xUrl|default }}',
        },
        {
            name: 'Vestiging: Pinterest URL',
            value: '{{ team.pinterestUrl|default }}',
        },
        {
            name: 'Vestiging: TikTok URL',
            value: '{{ team.tiktokUrl|default }}',
        },
        {
            name: 'Vestiging: Vimeo URL',
            value: '{{ team.vimeoUrl|default }}',
        },
    ];
}

function getMedewerkerMergeTags(namePrefix: string = 'Medewerker', valuePrefix: string = 'realworksMedewerker') {
    return [
        {
            name: `${namePrefix}: volledige naam`,
            value: `{{ ${valuePrefix}.volledigeNaam|default }}`,
        },
        {
            name: `${namePrefix}: e-mailadres`,
            value: `{{ ${valuePrefix}.emailadres|default }}`,
        },
        {
            name: `${namePrefix}: telefoonnummer`,
            value: `{{ ${valuePrefix}.telefoonnummer|default }}`,
        },
        {
            name: `${namePrefix}: mobielnummer`,
            value: `{{ ${valuePrefix}.mobieleTelefoonnummer|default }}`,
        },
    ];
}

function getWonenObjectMergeTags(namePrefix: string = 'Woning', valuePrefix: string = 'realworksWonenObject') {
    return [
        {
            name: `${namePrefix}: adres`,
            value: `{{ ${valuePrefix}.straat|default }}`,
        },
        {
            name: `${namePrefix}: adres (incl. postcode en woonplaats)`,
            value: `{{ ${valuePrefix}.adres|default }}`,
        },
        {
            name: `${namePrefix}: postcode`,
            value: `{{ ${valuePrefix}.postcode|default }}`,
        },
        {
            name: `${namePrefix}: woonplaats`,
            value: `{{ ${valuePrefix}.plaats|default }}`,
        },
        {
            name: `${namePrefix}: status`,
            value: `{{ ${valuePrefix}.status|default }}`,
        },
        {
            name: `${namePrefix}: prijs`,
            value: `{{ ${valuePrefix}.prijs||default(0)|format_number }}`,
        },
        {
            name: `${namePrefix}: prijstype (bijv. kosten koper)`,
            value: `{{ ${valuePrefix}.prijstype|default }}`,
        },
        {
            name: `${namePrefix}: aantal kamers`,
            value: `{{ ${valuePrefix}.aantalKamers|default }}`,
        },
        {
            name: `${namePrefix}: aantal slaapkamers`,
            value: `{{ ${valuePrefix}.aantalSlaapkamers|default }}`,
        },
        {
            name: `${namePrefix}: bouwjaar`,
            value: `{{ ${valuePrefix}.bouwjaar|default }}`,
        },
        {
            name: `${namePrefix}: bouwvorm (nieuwbouw of bestaande bouw)`,
            value: `{{ ${valuePrefix}.bouwvorm|default }}`,
        },
        {
            name: `${namePrefix}: energielabel`,
            value: `{{ ${valuePrefix}.energieklasse|default }}`,
        },
        {
            name: `${namePrefix}: soort woning (bijv. eengezinswoning)`,
            value: `{{ ${valuePrefix}.woonhuissoort|default }}`,
        },
        {
            name: `${namePrefix}: type woning (bijv. tussenwoning)`,
            value: `{{ ${valuePrefix}.woonhuistype|default }}`,
        },
        {
            name: `${namePrefix}: woonoppervlakte`,
            value: `{{ ${valuePrefix}.woonoppervlakte|default }}`,
        },
    ];
}
